import { ProductModelType, productTypesInversed } from '@teinor/erp/types/company/product'
import { connect, ConnectedProps } from 'react-redux'
import { parseSelectedCategories } from '../../../../../../../../../../app/erp/screens/Logistic/ProductsParent/Products/SingleProduct/function'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import ProductCategories from '../../../../../../../../../../baseComponents/Product/ProductCategories'
import TwinTrans from '../../../../../../../../../../baseComponents/TwinTrans'
import FormRenderer from '../../../../../../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import useLangData from '../../../../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { getActiveLangs } from '../../../../../../../../../../utils/reducers/getters'
import { GroupVatPayload } from '../../../../../../../../../../utils/reducers/globals/groupVats'
import { BrandsPayload } from '../../../../../../../../../../utils/reducers/products/brands'
import RelatedProducts from '../../../../../../../../../Product/ProductLayout/Subcomponents/RelatedProducts'
import { ProductImageModelType } from '@teinor/erp/types/company/product/productImage'
import { Fragment, useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import LoadingSpinner from '../../../../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { ModifiedProductLangModelType } from '../../../../../../../../../Product/types'
import { CollectionsPayload } from '../../../../../../../../../../utils/reducers/products/collections'

type MainEditProductOrderTabProps = ModalEditComponentProps & {
    basicData?: TwinDictionary
}

type ProductModelTypeExtended = ModifiedProductLangModelType & ProductModelType & {
    LangId?: string
}

const MainEditProductOrderTab: React.FC<MainEditProductOrderTabProps & ReduxProducts> = ({ basicData, brands, groupVats, collections }) => {
    const { t } = useTwinTranslation()
    const { selectedLang, data, changeLang } = useLangData({ myData: basicData?.ProductLangs, fieldsToLang: ['name', 'shortDescription', 'description', 'descriptionDocuments', 'shortDescriptionDocuments'], keyValue: 'LangId' })

    if (!basicData || !groupVats || !brands || !collections) {
        return null
    }

    const fields: FormRender<ProductModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    disabled: true,
                    defaultValue: data?.['name'][selectedLang] ?? '',
                },
            ]
        },
        {
            cols: 1,
            elements: [
                {
                    name: 'shortDescription',
                    label: t('shortDescription', 'Descripción breve'),
                    component: 'TwinEditor',
                    readOnly: true,
                    defaultValue: data?.['shortDescription'][selectedLang] ?? '',
                }
            ]
        },
        {
            cols: 1,
            elements: [
                {
                    name: 'description',
                    label: t('largeDescription', 'Descripción larga'),
                    component: 'TwinEditor',
                    readOnly: true,
                    defaultValue: data?.['description'][selectedLang] ?? '',
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.['id']
                },
            ]
        }
    ]
    const rightFields: FormRender<ProductModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang
                },
                {
                    name: 'reference',
                    label: t('reference', 'Referencia'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    disabled: true,
                    defaultValue: basicData?.['reference']
                },
                {
                    name: 'BrandId',
                    label: t('brand', 'Marca'),
                    component: 'CustomSelectWithSearchBar',
                    items: brands || {},
                    readOnly: true,
                    value: basicData?.BrandId
                },
                {
                    name: 'CollectionId',
                    label: t('collection', 'Colección'),
                    component: 'CustomSelectWithSearchBar',
                    items: collections || {},
                    readOnly: true,
                    value: basicData?.CollectionId
                },
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {},
                    readOnly: true,
                    value: basicData?.GroupVatId
                },
                {
                    name: 'uniqueProduct',
                    label: t('uniqueProduct', 'Producto único'),
                    component: 'Checkbox',
                    disabled: true,
                    defaultChecked: basicData.uniqueProduct
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                },
            ]
        },
    ]
    const typeP = basicData?.productType
    const haveCategories = typeP !== productTypesInversed['packaging'] && typeP !== productTypesInversed['addon']
    return (
        <div className='modal_negative_margin flex flex-auto flex-col'>
            <div className='flex flex-col overflow-auto flex-auto h-1'>
                <div className='flex h-full flex-wrap product_modal_container'>
                    <div className='flex w-3/5 first_main_form_product'>
                        <div className='flex-auto'>
                            <RenderImages ProductId={basicData?.id}/> 
                            <FormRenderer className='mb-20' sections={fields} antiUnsaveTrigger={true} />
                            <RelatedProducts relatedProducts={basicData?.RelatedProductsParsed} ProductId={basicData?.id} userPermissions={{ n: 1, permission: 'read' }}  />
                        </div>
                        <div className='vertical_separator_product'></div>
                    </div>
                    <div className='flex flex-col w-2/5 notFlexAutoFormRender second_main_form_product'>
                        <FormRenderer sections={rightFields} antiUnsaveTrigger={true} />
                        {haveCategories ?
                            <Fragment>
                                <span className='regular16 mt-25 mb-25 block'>
                                    <TwinTrans transKey='categories'>Categorías</TwinTrans>
                                </span>
                                <ProductCategories selectedCategories={parseSelectedCategories(basicData?.CategoriesProducts) || []} productType={basicData.productType} categoryProducts={basicData.CategoriesProducts} className='flex-auto cursor-default mainedit_product_order_tab' readOnly={true}  />
                            </Fragment>
                        : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

interface RenderImagesProps extends RenderImagesLogicProps {}

const RenderImages: React.FC<RenderImagesProps> = ({ProductId}) => {
    const { images } = useRenderImagesLogic({ ProductId })
    const renderThis: JSX.Element[] = []

    if (!images) {
        return <LoadingSpinner />
    }
    if (!images.length) {
        return null
    }
    if (images) {
        for (const element of images) {
            renderThis.push(
                <div className='product_image_container' key={element.id}>
                    <img title='img' className={'product_image'} src={element.url} alt='' />
                </div>
            )
        }
    }
    return (
        <div className='flex-auto mb-10'>
            <label className='input_field_label text-gray-51 mb-10 block'>
                <TwinTrans transKey='productImages'>Imágenes del producto</TwinTrans>
            </label>
            <div className='product_images_container flex relative'>
                <div className={'flex flex-wrap w-full'}>
                    <div className='container_product_images' >
                        {renderThis}
                    </div>
                </div>
            </div>
        </div>
    )
}


interface RenderImagesLogicProps {
    ProductId: number
}

const useRenderImagesLogic = ({ ProductId }: RenderImagesLogicProps) => {
    const [images, setImages] = useState<ProductImageModelType[] | null>(null)

    const getImages = useCallback(async () => {
        const data = await twinFetchPostJSON('/api/app/product/productImage/getAllProductImages', { ProductId })
        setImages(data)
    }, [setImages, ProductId])

    useEffect(() => {
        getImages()
    }, [getImages])


    return { images }
}

const productDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
    setBrands: (payload: BrandsPayload) => ({ type: 'CHANGE_BRANDS', payload }),
    setCollections: (payload: CollectionsPayload) => ({ type: 'CHANGE_COLLECTIONS', payload }),
}

const mapMainEditProductOrderTabConnect = (state: AllReduxPayloads) => ({ groupVats: state.groupVats, brands: state.brands, collections: state.collections })
const mainEditProductOrderTabConnect = connect(mapMainEditProductOrderTabConnect, productDispatch)
export type ReduxProducts = ConnectedProps<typeof mainEditProductOrderTabConnect>

const mainEditProductOrderTabLoading = withLoading(MainEditProductOrderTab, [
    { fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' },
    { fetchUrl: '/api/app/product/brand/getAllBrands', propName: 'brands', setFunctionName: 'setBrands' },
    { fetchUrl: '/api/app/product/collection/getAllCollections', propName: 'collections', setFunctionName: 'setCollections' }
])

const MainEditProductOrderTabConnect = mainEditProductOrderTabConnect(mainEditProductOrderTabLoading)


export default MainEditProductOrderTabConnect